import boardFunctionType from '../../constants-v2/crm/board-function-type.js';

export default {
  fromValue(value) {
    const key = Object.entries(boardFunctionType).find(([k, v]) => v === value);
    const type = key?.[0]?.split('_')?.[0];
    return boardFunctionType[`${ type }_NAME`];
  },
};
